module.exports = __webpack_public_path__ + "img/IMG_20180712_204326.f90e3a62.jpg";